import { FormControlLabel, TextField, Alert, Box, Button } from '@mui/material'
import { styled } from '@mui/system'
import { v4 as uuidv4 } from 'uuid'

import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'

import ModalHeader from 'components/modal/modal-header'

import { closeModal } from 'actions/app'

import { createOperator, editOperator } from 'api/operator'
import { find } from 'es-toolkit/compat'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useRef, useState } from 'react'
import { get } from 'es-toolkit/compat'

export type AddOperatorProps = {
  selectedOperator?: {
    id: string
    name: string
  }
}

export default function AddOperator(props: AddOperatorProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const operators = useSelector((state) =>
    get(state, 'account.operatorsList', []),
  )

  const [operatorName, setOperatorName] = useState('')
  const [error, setError] = useState(false)

  const closePopup = () => dispatch(closeModal())

  const onChangeOperator = (e) => setOperatorName(e.target.value)

  const firstUpdate = useRef(true)

  useEffect(() => {
    if (props.selectedOperator) {
      setOperatorName(props.selectedOperator.name)
    } else {
      setOperatorName('')
    }
  }, [])

  useEffect(() => {
    //To fix the error, seeing the item exists message on edit item
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    if (
      operators &&
      find(operators, ['name', operatorName]) !== undefined &&
      operatorName !== ''
    ) {
      setError(true)
    } else {
      setError(false)
    }
  }, [operatorName])

  const saveOperator = useCallback(() => {
    if (props?.selectedOperator) {
      const updatedOperator = {
        name: operatorName,
      }

      //@ts-expect-error
      dispatch(editOperator(props.selectedOperator.id, updatedOperator))
    } else {
      // Create a new operator with a unique ID
      const newOperator = {
        id: uuidv4(),
        name: operatorName,
      }
      //@ts-expect-error
      dispatch(createOperator(newOperator))
    }
  }, [operatorName])

  return (
    <ModalContainer>
      <ModalHeader>
        {props?.selectedOperator ? t('edit_operator') : t('add_operator')}
      </ModalHeader>
      <Box sx={{ my: '10px' }} style={{ display: error ? 'block' : 'none' }}>
        {error && !props?.selectedOperator ? (
          <Alert severity="warning">
            {t('item_name_exists', {
              item: t('operator'),
            })}
          </Alert>
        ) : null}
      </Box>
      <StyledForm>
        <FormControlLabel
          control={
            <TextField
              id="operator-name"
              name="operatorName"
              variant="outlined"
              size="small"
              placeholder={t('operator_name')}
              sx={{ marginLeft: '10px' }}
              value={operatorName}
              onChange={onChangeOperator}
              helperText={
                operatorName.length >= 40
                  ? t('input_character_limit', {
                      character_count: 40,
                      field_name: t('operator_name'),
                    })
                  : ''
              }
              error={operatorName.length >= 40}
              slotProps={{
                htmlInput: { maxLength: 40 },
              }}
            />
          }
          label={t('operator')}
          labelPlacement="start"
        />
      </StyledForm>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={saveOperator}
          disabled={!operatorName.length || error}
        >
          {props.selectedOperator ? t('edit') : t('add')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}

const StyledForm = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '& > *:not(:last-child)': {
    marginBottom: '1em',
  },
})
